import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.scss';
import reportWebVitals from './reportWebVitals';
import "./NiceModalRegistry";
import { Provider } from 'react-redux';
import {store} from './redux/Store';
import { createWeb3Modal, defaultConfig } from '@web3modal/ethers/react'
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { NETWORKS, web3ModalProjectId } from './constants';
import { Toaster } from 'react-hot-toast';


const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false, 
    },
  },
});
// const BASE = {
//   chainId: NETWORKS[0]?.chainId,
//   name: NETWORKS[0]?.value,
//   currency: NETWORKS[0]?.value,
//   explorerUrl: NETWORKS[0]?.explorerUrl,
//   rpcUrl: NETWORKS[0]?.rpc,
// };


const holskyTestnet = {
  chainId: 17000, // Correct Chain ID for Holsky Testnet
  name: 'Holsky',
  currency: 'ETH',
  explorerUrl: 'https://holesky.beaconcha.in', // Replace if Holsky-specific explorers exist
  rpcUrl: 'https://1rpc.io/holesky' // Use the official Holsky RPC endpoint
}
const projectId = web3ModalProjectId

const metadata = {
  name: 'Strong Hold',
  description: 'Strong Hold',
  url: 'https://stage-tokel-api.staging-host.com/v1', 
  icons: ['https://avatars.mywebsite.com/']
}

createWeb3Modal({
  excludeWalletIds: [
    '971e689d0a5be527bac79629b4ee9b925e82208e5168b733496a09c0faed0709',
    '5e4a8cc31d062b78a7ad9e017135574809b01c4dbbf30e4dbb467ddd43025618',
    '38f5d18bd8522c244bdd70cb4a68e0e718865155811c043f052fb9f1c51de662',
  ],
  ethersConfig: defaultConfig({
    metadata,
    defaultChainId: 17000,
    enableEIP6963: true,
    enableInjected: false,
    auth: {
      email: false,
      socials: undefined,
      showWallets: false,
      walletFeatures: false
  },
  
  }),
  allWallets: 'HIDE',
  chains: [holskyTestnet],
  projectId,
});
console.log(window)
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
    <Provider store={store}>
    <Toaster />
      <App />
    </Provider>
    </QueryClientProvider>
  </React.StrictMode>
);

reportWebVitals();
